import { Image } from "antd";
import type { ImageProps } from "antd";
import { s3FallbackUrl } from "../utils/mediaFallback";

/**
 * Drop-in replacement for antd's <Image> that automatically falls back to the
 * S3 backup copy when the primary (server) src fails to load.
 *
 * Use this instead of importing antd's <Image> directly for any server-hosted
 * media, so every image is covered without wiring `fallback` by hand. Pass any
 * antd Image prop through as usual; an explicit `fallback` prop still wins.
 */
export default function S3Image({ src, fallback, ...rest }: ImageProps) {
  const computed =
    fallback ??
    (s3FallbackUrl(typeof src === "string" ? src : undefined) || undefined);
  return <Image src={src} fallback={computed} {...rest} />;
}
